module.exports = __webpack_public_path__ + "static/img/case3.56bac7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCase/case3.jpg
// module id = t5un
// module chunks = 1